export const getCookieValue = name => document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
export const eraseCookie = name => (document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`)
